const initialState = {
    data: null,
}
export const PrintPDFFileReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PRINTPDF_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'PRINTPDF_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default PrintPDFFileReducer;
